module.exports = __webpack_public_path__ + "static/media/whatsapp.03137efd.svg";